import Model, { attr } from '@ember-data/model';
import currency from 'currency.js';

export default class FundSummaryRollingGoalModel extends Model {
  @attr('number') declare monthlyGoal: number;
  @attr('number') lastYearAvgAmount?: number;
  @attr('number') pledgedNoGiftsAmount?: number;
  @attr('number') pledgedDelinquentAmount?: number;
  @attr('number') pledgedGivingAmount?: number;
  @attr('number') pledgedMonthlyAmount?: number;

  get annualGoal() {
    return currency(this.monthlyGoal).multiply(12).value;
  }

  lastYearAnnualAmount() {
    return currency(this.lastYearAvgAmount || 0).multiply(12).value;
  }

  get lastYearAvgPercentage() {
    return Math.round(((this.lastYearAvgAmount || 0) * 100) / this.monthlyGoal);
  }

  get pledgedNoGiftsPercent() {
    return Math.round(
      ((this.pledgedNoGiftsAmount || 0) * 100) / this.monthlyGoal,
    );
  }

  get pledgedDelinquentPercent() {
    return Math.round(
      ((this.pledgedDelinquentAmount || 0) * 100) / this.monthlyGoal,
    );
  }

  get pledgedGivingPercent() {
    return Math.round(
      ((this.pledgedGivingAmount || 0) * 100) / this.monthlyGoal,
    );
  }

  get pledgedAllAmount() {
    return (
      (this.pledgedNoGiftsAmount || 0) +
      (this.pledgedDelinquentAmount || 0) +
      (this.pledgedGivingAmount || 0)
    );
  }

  get pledgedAllPercent() {
    return Math.round(((this.pledgedAllAmount || 0) * 100) / this.monthlyGoal);
  }

  get pledgedAnnualAmount() {
    return currency(this.pledgedMonthlyAmount || 0).multiply(12).value;
  }

  get pledgedMonthlyPercent() {
    return Math.round(
      ((this.pledgedMonthlyAmount || 0) * 100) / this.monthlyGoal,
    );
  }
}
